<template>
  <div class="form-container yy-form-con"
    :id="code"
  >
    <div
      ref="form-mask"
      class="form-mask"
      :code="code"
      :loading="loading"
    >
    </div>
    <div
      ref="form-warrper"
      :formCode="code"
      class="form-warrper"
    >
      <form-header
        :title="title"
        :buttons="buttons"
        @button-method="buttonMethod"
        @destroy="destroy"
      >
      </form-header>
      <form-body
        :isBlock="isBlock"
        :paramsModel="items"
        v-model="submitData"
        :resouceType="report = 'form'"
        :code="code"
        :script="script"
        :subForms="subForms"
        ref="formBody"
        :formData="true"
        :inForm="true"
        :loadingData="loadingData"
        :labelWidth="labelWidth"
      >
      </form-body>
    </div>
  </div>
</template>
<script>
  import reportHeader from '@/views/report/components/reportHeader.vue'
  import reportParams from '@/views/report/components/reportParams.vue'
  import { exportSend } from '@/api/report.js'
  import { getFromMetaData, submitForm, getFormData } from '@/api/form.js'
  import formMixin from './mixins/formMixin'
  import commonMixin from '../../mixins/common.js'
  import helpService from '@/utils/manager'
  import { closeOutRequestLoading as closeLoading } from '@/utils/loading.js'

  // import _ from 'lodash'
/* eslint-disable */
  export default {
    name: 'base-form',
    components: {
      'form-header': reportHeader,
      'form-body': reportParams
    },
    mixins: [commonMixin, formMixin],
    activated() {
      closeLoading()
    },
    beforeMount() {
      if(!this.isDialog){
        this.$store.dispatch('changeViewTitle',{path:this.$route.fullPath,title: this.title})
      }
      const method = this.$route.query && this.$route.query.method
      if(!method){
         closeLoading()
      }
      helpService.dealCss(this.code, this.css)
    },
    props: {
      isDialog: {
       default: false
     },
      isBlock: {
        type: Boolean | undefined
      },
      code: {
        type: String
      },
      title: String,
      items: Array,
      buttons: Array,
      path: String,
      subForms: {
        type: Array,
        default() {
          return []
        }
      },
      autoFocus: {
        type: Boolean,
        default: false
      },
      css: String,
      script: String,
      labelWidth:{
        type: Number,
        default: 120
      }
    },
    data() {
      return {
        loading: false,
        loadingData: true,
        submitData: {},
        status: 'add',
        disable: false,
        dynamicWatches: [],
        inForm: true
      }
    },
    watch: {
      path: {
        handler(val) {
          if (val) {
            const method = this.$route.query && this.$route.query.method
            if (method) {
              const query = this.$route.query
              let tempUrl = _.cloneDeep(val)
              for (const i in query) {
                tempUrl = _.replace(tempUrl, '{' + i + '}', query[i])
              }
              this.$nextTick(() => {
                let params = Object.assign({noLoading: true},this.$route.query)
                getFormData(tempUrl, params).then((res) => {
                  this.dealDetailData(res)
                  this.$eventBus.$emit('edit', res.data)
                  closeLoading()
                  this.loadingData = false
                }).catch(()=>{
                  closeLoading()
                })
              })
              if (method === 'detail') {
                this.disableAllInput()
              }
            } else {
              closeLoading()
              this.loadingData = false
            }
          }
        },
        immediate: true,
        deep: true
      },
      items: {
        handler() {
          this.dealSubmitData()
        },
        immediate: true,
        deep: true
      }
    },
    beforeDestroy() {
      this.dynamicWatches.forEach(unwatch => {
        unwatch()
      })
      helpService.removeScriptOrCss(this.code)
    },
    methods: {
      destroy() {
        this.$nextTick(() => {
          this.$destroy()
        })
      },
      dealDetailData(res) {
        if (res.code === 0) {
          this.submitData = res.data
          if (this.subForms && this.subForms.length > 0) {
            this.submitData.subForms = []
            this.subForms.forEach((subForm, index) => {
              const name = subForm.code
              const value = res.data[name] || {}
              this.submitData.subForms.push(value)
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: res.message,
            showClose: true
          })
        }
      },
      deactivated() {
        this.$destroy()
      },
      disableAllInput() {
        this.items.forEach((item) => {
          this.$set(item, 'disabled', true)
        })
      },
      dealSubFormSubmit() {
        if (this.submitData.subForms) {
          this.submitData.subForms.forEach((subForm, index) => {
            const name = this.subForms[index].code
            this.submitData[name] = subForm
          })
          delete this.submitData.subForms
        }
      },
      submitThisForm(event, otherParams = {}) {
        this.dealSubFormSubmit()
        const params = _.merge({}, { code: this.code },otherParams, this.submitData, this.$route.query)
        submitForm(event.path, params).then(res => {
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '保存成功',
              showClose: true
            })
            if(!this.isDialog){
              this.goBack()
            }else{
              if(event.callback && event.callback.refresh){
                this.$eventBus.$emit('refresh-table-from-dialog')
              }
              if(event.callback && event.callback.autoClose){
                this.$eventBus.$emit('hide-dialog')
              }
            }
            this.$nextTick(() => {
              setTimeout(() => {
                this.$bus.$emit('refresh-grid')
              }, 300)
            })
          } else {
            this.$message({
              type: 'error',
              message: res.message,
              showClose: true
            })
          }
        }).catch((error) => {
          this.$message({
            type: 'error',
            message: error,
            showClose: true
          })
        })
      },
      exportThisForm(event, otherParams = {}) {
        const fileName = event.fileName || '导出数据.xls'
        this.dealSubFormSubmit()
        const params = _.merge({}, { code: this.code },otherParams, this.submitData, this.$route.query)
        console.log(params)
        exportSend(event.path, 'post', params).then(res => {
          const blob = res.data
          var a = document.createElement('a')
          var url = window.URL.createObjectURL(blob)
          a.href = url
          a.download = fileName
          a.click()
          window.URL.revokeObjectURL(url)
        })
      },
      getMeatData: function() {
        const params = {
          code: this.code
        }
        getFromMetaData(params).then((res) => {
          const data = res.data
          const meta = data.meta
          this.title = meta.title
          this.items = meta.items
          this.buttons = meta.buttons
          this.dealSubmitData()
          this.$nextTick(() => {
            this.loading = false
          })
        })
      },
      submitMethod(event, otherParams) {
        this.$refs.formBody.confirm(event).then(() => {
          this.submitThisForm(event, otherParams)
        })
      },
      exportMethod(event, otherParams) {
        this.$refs.formBody.confirm(event).then(() => {
          this.exportThisForm(event, otherParams)
        })
      },
      dealSubmitData() {
        const model = {}
        const textArr = []
        const subForms = []
        this.items.forEach((item, index) => {
          model[item.name] = item.value || ''
          if (item.inputModel === 'inputDia') {
            textArr.push(item)
          }
        })
        // 开始处理子表单
        if (this.subForms) {
          this.subForms.forEach((subForm, index) => {
            subForms.push(subForm.values || [])
          })
        }
        model.subForms = subForms

        this.submitData = model
        this.$nextTick(() => {
          this.$eventBus.$emit('textValue', textArr)
        })
      },
      buttonMethod(event) {
        const type = event.type
        this[type + 'Method'] && this[type + 'Method'](event)
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .form-container{
    display: flex;
    max-width:100%;
    display: -mox-flex;
    display: -webkit-flex;
    display: -ms-flexbox;
    display:block\9;
    flex-direction: column;
    .form-warrper{
      flex: 1;
      flex: 1 1 0%;
      display: flex;
      flex-direction: column;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/baseForm/index.vue